import CardOption from '../card_option/element.js';
import style from './style.lit.css';

/**
 * Represents one option when voting for dates.
 *
 * @slot default - Title/label
 * @slot avatars - Avatar list of helpers
 */

export default class DateOption extends CardOption {
  static styles = [CardOption.styles, style];

  /** @internal */
  static config = {
    icons: {
      plus: '',
      minus: 'check',
      check: 'check',
    },
  };

  /** @internal */
  get checkUrl() {
    return `/cards/${this.cardId}/options/${this.itemId}/vote`;
  }

  /** @internal */
  get detailsUrl() {
    return `/date_cards/${this.cardId}/votes?option=${this.itemId}`;
  }

  uncheckAction() {
    return this.commonActions.post(this.checkUrl);
  }
}

customElements.get('ef-date-option') ||
  customElements.define('ef-date-option', DateOption);
